var styles = [".tab-content[_ngcontent-%COMP%]{height:100%}"];
export { styles as styles };
